<script>
// import BaseModal from '@/components/_common/modal/BaseModal'
export default {
  name: 'StoreView',
  components: {
    // BaseModal
  },
  data () {
    return {
      images: [
        {
          src: '/img/promo/book/cover.webp',
          title: 'book cover'
        },
        {
          src: '/img/promo/book/p1.webp',
          title: 'page 1'
        },
        {
          src: '/img/promo/book/p2.webp',
          title: 'page 2'
        },
        {
          src: '/img/promo/book/p34.webp',
          title: 'page 34'
        },
        {
          src: '/img/promo/book/p35.webp',
          title: 'page 35'
        }
      ]
    }
  },
  methods: {
  }
}
</script>

<template>
  <section
    class="store-view promo-view"
  >
    <header class="container mobile-container">
      <h1 class="view-title">
        Bookstore
      </h1>
      <div
        class="view-subtitle"
      >
        Books from our friends and advisors
      </div>
    </header>
    <div class="bookshelf">
      <div class="container mobile-container">
        <div class="book-grid-item py-5">
          <router-link
            class="trial-button"
            :to="{ name: 'BookIppraView', params: {stickyNav: true}}"
          >
            <div class="book-cover">
              <b-image
                src="/img/promo/book/ippra/cover.webp"
                alt="IPPRA cover"
                ratio="324by486"
              />
            </div>
          </router-link>
          <div>
            <div class="book-title">
              <router-link
                class="trial-button"
                :to="{ name: 'BookIppraView', params: {stickyNav: true}}"
              >
                Indicators of Primitive and Postural Reflexes Assessment (IPPRA)
              </router-link>
            </div>
            <div class="book-byline">by Patti Andrich</div>
            <div class="book-description">
<!--              <div class="mt-2">-->
<!--                Primitive reflex activity and immature postural reflexes can have a significant impact on the quality of life.-->
<!--                The presence of primitive reflex activity beyond the typical period of infancy often contributes to a slew of behavior/emotional,-->
<!--                academic/cognitive, motor coordination, sensory regulation, and/or anxiety issues.-->
<!--                Coping with adverse effects of aberrant reflex activity is not limited to children.-->
<!--                Some adults, often unknowingly, also cope with residual reflex activity.-->
<!--                When aberrant reflex activity continues to be present through adulthood or remerges at some point during the lifespan,-->
<!--                one may have difficulty performing daily tasks.-->
<!--              </div>-->
              <div class="mt-2">
                Primitive reflex activity and immature postural reflexes can have a significant impact on the quality of life.
                The presence of primitive reflex activity beyond the typical period of infancy often contributes to a slew of behavior/emotional,
                academic/cognitive, motor coordination, sensory regulation, and/or anxiety issues.
              </div>
              <div class="mt-2">
                <span class="is-family-semibold mr-1">The Indicators of Primitive and Postural Reflexes Assessment (IPPRA)</span> provides a repeatable
                testing and scoring system that quantifies qualitative data. The testing procedures describe how the examiner is to position the individual being tested for each of the reflex tests. Individuals assume specific postures and are then prompted to move
                through specific motions. The examiner observes the physical and emotional responses to each of
                the tests. The IPPRA provides video examples for scoring.
              </div>
            </div>
            <router-link
              class="trial-button"
              :to="{ name: 'BookIppraView', params: {stickyNav: true}}"
            >
              <button class="button is-primary mt-2">
                <span class="is-family-semibold">Details</span><span class="icon is-medium ml-1"><i class="mdi mdi-24px mdi-arrow-right"/></span>
              </button>
            </router-link>
          </div>
        </div>
        <hr class="p-0 m-0">
        <div class="book-grid-item py-5">
          <router-link
            class="trial-button"
            :to="{ name: 'BookSeeAndSayView', params: {stickyNav: true}}"
          >
            <div class="book-cover">
              <b-image
                src="/img/promo/book/see-and-say/cover.webp"
                alt="IPPRA cover"
                ratio="324by486"
              />
            </div>
          </router-link>
          <div>
            <div class="book-title">
              <router-link
                class="trial-button"
                :to="{ name: 'BookSeeAndSayView', params: {stickyNav: true}}"
              >
                See and Say, See and Say, Find It, Say It, Dream It, Do It!
              </router-link>
            </div>
            <div class="book-byline">by Lisa Erskine Knopp</div>
            <div class="book-description">
              <div class="mt-2">
                This ‘Seussical’ rhyming flip book story is about three animal friends on a playful
                “See and Say” walking adventure, leading the characters/readers to cloud and
                nighttime sky viewing for building the visual skills of Anti-Suppression, Figure
                Ground, and more.
              </div>
              <div class="mt-2">
                <span class="is-family-semibold mr-1"><em>Find It, Say It, Dream It, Do It</em></span> introduces the "superpowers" of Viewing with
                Intention, Visualization, Dreaming and Creating a powerful, fulfilling life that
                satisfies your heart’s desires.
              </div>
            </div>
            <router-link
              class="trial-button"
              :to="{ name: 'BookSeeAndSayView', params: {stickyNav: true}}"
            >
              <button class="button is-primary mt-2">
                <span class="is-family-semibold">Details</span><span class="icon is-medium ml-1"><i class="mdi mdi-24px mdi-arrow-right"/></span>
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<style lang="scss" scoped>
  .store-view {
    background-color: $empty-background;
    .book-container {
      padding: 2rem 0;
    }
    .bookshelf {
      background-color: $eggshell;
    }
    .book-cover {
      max-width: 8rem;
      @include tablet {
        max-width: none;
      }
    }
    .book-grid-item {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 1rem;
      @include tablet {
        grid-template-columns: 10rem auto;
      }
    }
    .about-row {
      @include desktop {
        display:flex;
      }
      .history-article {
        @include desktop {
          flex-grow:1;
          margin-right: 1rem;
        }
      }
    }
  }
  .book-title {
    font-size: 1.5rem;
    line-height: 1.5rem;
    font-family: $family-semibold;
    color: $feldgrau;
  }
  .book-byline {
    font-size: 1.25rem;
    font-family: $family-semibold;
    color: $feldgrau;
  }
  .carousel-container {
    border: 1px solid $empty-background;
    padding: 1rem 1rem 0.5rem 1rem;
  }
</style>
<style lang="scss">
.store-view {
  .is-active .al img {
    filter: grayscale(0%);
    border: 1px solid $primary;
  }
  .al img {
    filter: grayscale(100%);
  }
}
</style>
